import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { AuthLayout } from '../components/AuthLayout';
import { LoginForm } from '../components/LoginForm';
import { useNavigate } from 'react-router-dom';

export const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !password) {
      return;
    }

    try {
      setIsLoading(true);
      const result = await login(email, password);
      if (result.needsOTP) {
        navigate('/auth/otp', { state: { email: result.email || email } });
      }
    } catch (error: any) {
      // useAuth đã set error vào Redux
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggleMode = () => {
    navigate('/auth/register');
  };

  const handleGoogleLogin = () => {
    // TODO: Implement Google OAuth
    console.log('Google login clicked');
  };

  return (
    <AuthLayout>
      <LoginForm
        isRegisterMode={false}
        email={email}
        password={password}
        displayName=""
        isLoading={isLoading}
        error={error}
        onEmailChange={setEmail}
        onPasswordChange={setPassword}
        onDisplayNameChange={() => {}}
        onSubmit={handleSubmit}
        onToggleMode={handleToggleMode}
        onGoogleLogin={handleGoogleLogin}
      />
    </AuthLayout>
  );
};